export const SET_CHECKOUT_DATA = 'SET_CHECKOUT_DATA';
export const SET_CHECKOUT_SALON_TAXES_AND_FEES = 'SET_CHECKOUT_SALON_TAXES_AND_FEES';
export const SET_CHECKOUT_INIT_DATA_FROM_CASHUP = 'SET_CHECKOUT_INIT_DATA_FROM_CASHUP';
export const SET_CHECKOUT_TOTAL = 'SET_CHECKOUT_TOTAL';
export const ADD_CLIENT = 'ADD_CLIENT';
export const REMOVE_CLIENT = 'REMOVE_CLIENT';
export const ADD_SERVICE = 'ADD_SERVICE';
export const REMOVE_SERVICE = 'REMOVE_SERVICE';
export const UPDATE_SERVICE_STYLIST_ID = 'UPDATE_SERVICE_STYLIST_ID';
export const UPDATE_SERVICE_PRICE = 'UPDATE_SERVICE_PRICE';
export const UPDATE_SERVICE_DISCOUNT = 'UPDATE_SERVICE_DISCOUNT';
export const CHANGE_SERVICE_DISCOUNT_TYPE = 'CHANGE_SERVICE_DISCOUNT_TYPE';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const UPDATE_PRODUCT_STYLIST_ID = 'UPDATE_PRODUCT_STYLIST_ID';
export const UPDATE_PRODUCT_TITLE = 'UPDATE_PRODUCT_TITLE';
export const UPDATE_PRODUCT_PRICE = 'UPDATE_PRODUCT_PRICE';
export const UPDATE_PRODUCT_DISCOUNT = 'UPDATE_PRODUCT_DISCOUNT';
export const CHANGE_PRODUCT_DISCOUNT_TYPE = 'CHANGE_PRODUCT_DISCOUNT_TYPE';
export const UPDATE_PRODUCT_QUANTITY = 'UPDATE_PRODUCT_QUANTITY';
export const UPDATE_ADDITIONAL_DISCOUNT = 'UPDATE_ADDITIONAL_DISCOUNT';
export const UPDATE_TIP_AMOUNT = 'UPDATE_TIP_AMOUNT';
export const CHANGE_TIP_TYPE = 'CHANGE_TIP_TYPE';
export const CHANGE_ADDITIONAL_DISCOUNT_TYPE = 'CHANGE_ADDITIONAL_DISCOUNT_TYPE';
export const UPDATE_ADDITIONAL_DISCOUNT_REASON = 'UPDATE_ADDITIONAL_DISCOUNT_REASON';
export const UPDATE_PART_CASH = 'UPDATE_PART_CASH';
export const UPDATE_OTHER_AMOUNT = 'UPDATE_OTHER_AMOUNT';
export const APPOINTMENT_REQUEST = 'APPOINTMENT_REQUEST';
export const APPOINTMENT_SUCCESS = 'APPOINTMENT_SUCCESS';
export const APPOINTMENT_FAILURE = 'APPOINTMENT_FAILURE';
export const TRANSACTION_DETAILS_REQUEST = 'TRANSACTION_DETAILS_REQUEST';
export const TRANSACTION_DETAILS_SUCCESS = 'TRANSACTION_DETAILS_SUCCESS';
export const TRANSACTION_DETAILS_FAILURE = 'TRANSACTION_DETAILS_FAILURE';

export const TRANSACTION_CREATE_REQUEST = 'TRANSACTION_CREATE_REQUEST';
export const TRANSACTION_CREATE_SUCCESS = 'TRANSACTION_CREATE_SUCCESS';
export const TRANSACTION_CREATE_FAILURE = 'TRANSACTION_CREATE_FAILURE';
export const TRANSACTION_EMAIL_REQUEST = 'TRANSACTION_EMAIL_REQUEST';
export const TRANSACTION_EMAIL_SUCCESS = 'TRANSACTION_EMAIL_SUCCESS';
export const TRANSACTION_EMAIL_FAILURE = 'TRANSACTION_EMAIL_FAILURE';
export const CLEAN_TRANSACTION_DATA = 'CLEAN_TRANSACTION_DATA';

export const PRODUCT_LIST_REQUEST = 'PRODUCT_LIST_REQUEST';
export const PRODUCT_LIST_SUCCESS = 'PRODUCT_LIST_SUCCESS';
export const PRODUCT_LIST_FAILURE = 'PRODUCT_LIST_FAILURE';

export const PRODUCT_CREATE_REQUEST = 'PRODUCT_CREATE_REQUEST';
export const PRODUCT_CREATE_SUCCESS = 'PRODUCT_CREATE_SUCCESS';
export const PRODUCT_CREATE_FAILURE = 'PRODUCT_CREATE_FAILURE';

export const CHECKOUT_CLIENT_REQUEST = 'CHECKOUT_CLIENT_REQUEST';
export const CHECKOUT_CLIENT_SUCCESS = 'CHECKOUT_CLIENT_SUCCESS';
export const CHECKOUT_CLIENT_FAILURE = 'CHECKOUT_CLIENT_FAILURE';

export const SET_CHECKOUT_INIT_DATA_FROM_MAIN_NAV = 'SET_CHECKOUT_INIT_DATA_FROM_MAIN_NAV';

export const GET_DEPOSIT_CLIENTS_LIST_REQUEST = 'GET_DEPOSIT_CLIENTS_LIST_REQUEST';
export const GET_DEPOSIT_CLIENTS_LIST_SUCCESS = 'GET_DEPOSIT_CLIENTS_LIST_SUCCESS';
export const GET_DEPOSIT_CLIENTS_LIST_FAILURE = 'GET_DEPOSIT_CLIENTS_LIST_FAILURE';

export const ADD_CLIENT_DEPOSITS = 'ADD_CLIENT_DEPOSITS';
export const ADD_CLIENT_SEARCH_DEPOSITS = 'ADD_CLIENT_SEARCH_DEPOSITS';

export const UPDATE_DEPOSIT_FROM_CHECKOUT = 'UPDATE_DEPOSIT_FROM_CHECKOUT';

export const USE_DEPOSIT_REQUEST = 'USE_DEPOSIT_REQUEST';
export const USE_DEPOSIT_SUCCESS = 'USE_DEPOSIT_REQUEST';
export const USE_DEPOSIT_FAILURE = 'USE_DEPOSIT_FAILURE';

export const UPDATE_DEPOSIT = 'UPDATE_DEPOSIT';
export const UPDATE_DEPOSITS = 'UPDATE_DEPOSITS';

export const CHECKOUT_FETCH_DEPOSIT_REQUEST = 'CHECKOUT_FETCH_DEPOSIT_REQUEST';
export const CHECKOUT_FETCH_DEPOSIT_SUCCESS = 'CHECKOUT_FETCH_DEPOSIT_SUCCESS';
export const CHECKOUT_FETCH_DEPOSIT_FAILURE = 'CHECKOUT_FETCH_DEPOSIT_FAILURE';
export const CHECKOUT_INIT_DEPOSIT_REQUEST = 'CHECKOUT_INIT_DEPOSIT_REQUEST';
export const CHECKOUT_INIT_DEPOSIT_SUCCESS = 'CHECKOUT_INIT_DEPOSIT_SUCCESS';
export const CHECKOUT_INIT_DEPOSIT_FAILURE = 'CHECKOUT_INIT_DEPOSIT_FAILURE';
export const TOGGLE_CHECKOUT_BUTTONS_ENABLED = 'TOGGLE_CHECKOUT_BUTTONS_ENABLED';

export const CHECKOUT_START_SESSION_REQUEST = 'CHECKOUT_START_SESSION_REQUEST';
export const CHECKOUT_START_SESSION_SUCCESS = 'CHECKOUT_START_SESSION_SUCCESS';

export const CHECKOUT_CLOSE_SESSION_REQUEST = 'CHECKOUT_CLOSE_SESSION_REQUEST';
export const CHECKOUT_CLOSE_SESSION_SUCCESS = 'CHECKOUT_CLOSE_SESSION_SUCCESS';
export const CHECKOUT_CLOSE_SESSION_FAILURE = 'CHECKOUT_CLOSE_SESSION_FAILURE';

export const CHECKOUT_ADD_PRODUCT_FROM_SCAN = 'CHECKOUT_ADD_PRODUCT_FROM_SCAN';

export const DEPOSIT_CLIENT_LIST_REQUEST = 'DEPOSIT_CLIENT_LIST_REQUEST';
export const DEPOSIT_CLIENT_LIST_SUCCESS = 'DEPOSIT_CLIENT_LIST_SUCCESS';
export const DEPOSIT_CLIENT_LIST_FAILURE = 'DEPOSIT_CLIENT_LIST_FAILURE';

export const UPDATE_CHECKOUT_COMPLETE = 'UPDATE_CHECKOUT_COMPLETE';

export const CHECKOUT_FETCH_ALL_DEPOSITS_REQUEST = 'CHECKOUT_FETCH_ALL_DEPOSITS_REQUEST';
export const CHECKOUT_FETCH_ALL_DEPOSITS_SUCCESS = 'CHECKOUT_FETCH_ALL_DEPOSITS_SUCCESS';
export const CHECKOUT_FETCH_ALL_DEPOSITS_FAILURE = 'CHECKOUT_FETCH_ALL_DEPOSITS_FAILURE';
export const FETCH_NEXT_APPOINTMENT_SUCCESS = 'FETCH_NEXT_APPOINTMENT_SUCCESS';
export const FETCH_NEXT_APPOINTMENT_REQUEST = 'FETCH_NEXT_APPOINTMENT_REQUEST';
export const FETCH_NEXT_APPOINTMENT_FAILURE = 'FETCH_NEXT_APPOINTMENT_FAILURE';
export const UNLOCK_DEPOSIT_REQUEST = 'UNLOCK_DEPOSIT_REQUEST';
export const UNLOCK_DEPOSIT_SUCCESS = 'UNLOCK_DEPOSIT_SUCCESS';
export const UNLOCK_DEPOSIT_FAILURE = 'UNLOCK_DEPOSIT_FAILURE';
export const EXPORT_TRANSACTION_REQUEST = 'EXPORT_TRANSACTION_REQUEST';
export const EXPORT_TRANSACTION_SUCCESS = 'EXPORT_TRANSACTION_SUCCESS';
export const EXPORT_TRANSACTION_FAILURE = 'EXPORT_TRANSACTION_FAILURE';
export const CLEAR_TRANSACTION_LOG = 'CLEAR_TRANSACTION_LOG';
export const CANCEL_SLICK_CARD_ONLINE = 'CANCEL_SLICK_CARD_ONLINE';
export const UPDATE_VOUCHERS_USED = 'UPDATE_VOUCHERS_USED';
